import React from 'react';
import { baseXUnit, font, fontSize, fontWeight } from '../../styles/theme';

interface TimLogoProps {
  size: number;
}

const TimLogo: React.FunctionComponent<TimLogoProps> = ({ size }) => {
  return (
    <div className="tim-logo" data-testid="vgm-text-logo">
      Golf <img src="/x-imt.svg" alt="x" className="accent-logo" /> IMT.fi
      {/*language=CSS*/}
      <style jsx>{`
        .tim-logo {
          font-family: ${font.primary};
          font-size: ${fontSize.px24};
          font-weight: ${fontWeight.bold};
          line-height: ${baseXUnit(size)};
          display: inline-flex;
          align-items: center;
          color: inherit;
        }
        .accent-logo {
          height: 0.8em;
          margin: 0 6px;
        }
      `}</style>
    </div>
  );
};

export default TimLogo;
